import request from '../utils/request';
import { getToken } from '../utils/auth';
import { API_BASE_URL, MEDIA_BASE_URL, API_PATHS } from './config';

const { VIDEO } = API_PATHS;
const BASE_URL = (API_BASE_URL || '').replace(/\/$/, '');
const MEDIA_URL = MEDIA_BASE_URL || BASE_URL;

/** 扫描视频入库（仅超管） */
export const scanVideos = (path) =>
    request(VIDEO.SCAN, {
        method: 'POST',
        body: JSON.stringify({ path }),
    });

/** 浏览可扫描目录（仅超管） */
export const browseVideoScanPath = (path) => {
    const qs = path ? `?path=${encodeURIComponent(path)}` : '';
    return request(`${VIDEO.SCAN_BROWSE}${qs}`, { method: 'GET' });
};

/** 视频列表（超管/管理员全部，普通用户已分配） */
export const listVideos = async ({ categoryId, tagId, signal } = {}) => {
    const params = new URLSearchParams();
    if (categoryId != null && categoryId !== '') {
        params.set('categoryId', String(categoryId));
    }
    if (tagId != null && tagId !== '') {
        params.set('tagId', String(tagId));
    }
    const qs = params.toString();
    const url = qs ? `${VIDEO.LIST}?${qs}` : VIDEO.LIST;
    const data = await request(url, { method: 'GET', signal });
    return Array.isArray(data) ? data : [];
};

/** 设置视频分类与标签（超管/管理员） */
export const updateVideoMeta = (videoId, { categoryId, tagIds } = {}) =>
    request(`${VIDEO.META_UPDATE}/${videoId}`, {
        method: 'POST',
        body: JSON.stringify({
            updateCategory: true,
            categoryId: categoryId ?? null,
            updateTags: true,
            tagIds: tagIds ?? [],
        }),
    });

/** 分类字典 */
export const listVideoCategories = async ({ signal } = {}) => {
    const data = await request(VIDEO.CATEGORY_LIST, { method: 'GET', signal });
    return Array.isArray(data) ? data : [];
};

export const createVideoCategory = (payload) =>
    request(VIDEO.CATEGORY_CREATE, {
        method: 'POST',
        body: JSON.stringify(payload),
    });

export const updateVideoCategory = (id, payload) =>
    request(`${VIDEO.CATEGORY_UPDATE}/${id}`, {
        method: 'POST',
        body: JSON.stringify(payload),
    });

export const deleteVideoCategory = (id) =>
    request(`${VIDEO.CATEGORY_DELETE}/${id}`, { method: 'POST' });

/** 标签字典 */
export const listVideoTags = async ({ signal } = {}) => {
    const data = await request(VIDEO.TAG_LIST, { method: 'GET', signal });
    return Array.isArray(data) ? data : [];
};

export const createVideoTag = (payload) =>
    request(VIDEO.TAG_CREATE, {
        method: 'POST',
        body: JSON.stringify(payload),
    });

export const updateVideoTag = (id, payload) =>
    request(`${VIDEO.TAG_UPDATE}/${id}`, {
        method: 'POST',
        body: JSON.stringify(payload),
    });

export const deleteVideoTag = (id) =>
    request(`${VIDEO.TAG_DELETE}/${id}`, { method: 'POST' });

export const getVideoById = (id) => request(`${VIDEO.GET_BY_ID}/${id}`, { method: 'GET' });

export const assignVideoAccess = (videoId, userId) =>
    request(`${VIDEO.ASSIGN}/${videoId}/user/${userId}`, { method: 'POST' });

export const revokeVideoAccess = (videoId, userId) =>
    request(`${VIDEO.REVOKE}/${videoId}/user/${userId}`, { method: 'POST' });

export const deleteVideo = (id) => request(`${VIDEO.DELETE}/${id}`, { method: 'POST' });

export const listVideoAccessUsers = (videoId) =>
    request(`${VIDEO.ACCESS}/${videoId}`, { method: 'GET' });

function appendPlayToken(base, videoId) {
    const path = `${base}${VIDEO.PLAY}/${videoId}`;
    const token = getToken();
    if (!token) {
        return path;
    }
    const sep = path.includes('?') ? '&' : '?';
    return `${path}${sep}token=${encodeURIComponent(token)}`;
}

/**
 * 正式播放地址：直连媒体服务；点击播放前会暂停列表预览以释放连接。
 */
export const getVideoPlayUrl = (videoId) => appendPlayToken(MEDIA_URL, videoId);

/**
 * 卡片预览地址：直连媒体服务（开发环境为 localhost:8080），减轻 devServer proxy 压力。
 */
export const getVideoPreviewUrl = (videoId) => appendPlayToken(MEDIA_URL, videoId);
